<template >
  <v-layout column>
    <v-flex>
      <v-card>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">
              {{ service }} <span class="ml-1">{{ $t("labels.status") }}</span>
            </h1>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout column>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.lock") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  :disabled="isLocked.disabled"
                  @change="updateLock"
                  v-model="isLocked.status"
                  :labels="true"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.cancel") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  :disabled="isCanceled.disabled"
                  @change="updateIsCanceled"
                  v-model="isCanceled.status"
                  :labels="true"
                  :sync="true"
                >
                </toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap>
              <v-flex>{{ $t("labels.autoCollect") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateAutoCollect"
                  v-model="autoCollect"
                  :labels="true"
                  :value="autoCollect"
                  :sync="true"
                >
                </toggle-button>
              </v-flex>
            </v-layout>
            <v-divider v-if="service === 'POS'"></v-divider>
            <v-layout row wrap v-if="service === 'POS'">
              <v-flex>{{ $t("labels.trial") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateIsTrial"
                  v-model="isTrial"
                  :labels="true"
                  :value="isTrial"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider v-if="service === 'POS'"></v-divider>
            <v-layout row wrap v-if="service === 'POS'">
              <v-flex>{{ $t("labels.seeOtherStore") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateShowOwnStores"
                  v-model="showOwnStores"
                  :labels="true"
                  :value="showOwnStores"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider v-if="service === 'POS'"></v-divider>
            <v-layout row wrap v-if="service === 'POS'">
              <v-flex>{{ $t("labels.forceUpdate") }}</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button
                  @change="updateForceUpdate"
                  v-model="forceUpdate"
                  :labels="true"
                  :value="forceUpdate"
                  :sync="true"
                ></toggle-button>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import locationService from "../service.js";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["serviceID", "service"],
  data() {
    return {
      status: null,
      isLocked: {
        status: false,
        disabled: false,
      },
      showOwnStores: false,
      isCanceled: {
        status: false,
        disabled: false,
      },
      isTrial: false,
      autoCollect: false,
      forceUpdate: false,
    };
  },
  created() {
    this.setStatus();
    this.setStoreStatus();
  },
  watch: {
    // Watch for location changes and refresh data
    location: {
      handler(newLocation, oldLocation) {
        // Refresh data when location changes
        if (newLocation && newLocation.storeID) {
          // Only refresh if store ID changed or this is the first load
          if (!oldLocation || newLocation.storeID !== oldLocation.storeID) {
            this.setStatus();
            this.setStoreStatus();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("location", ["location", "organization"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    setStoreStatus() {
      locationService
        .getStatusByCspID(this.location.CSPID)
        .then((result) => {
          console.log('getStatusByCspID response is ', result);
          this.forceUpdate = result.data.forceUpdate;
        })
        .catch((err) => {
          console.log('err', err);
          this.$swal(err.message, 'Was not found', 'error').then(() => {

          });
        });
    },
    setStatus() {
      return locationService
        .getStatus(this.location.storeID, this.serviceID)
        .then((result) => {
          this.status = result.data;
          this.isLocked.status = this.status.isLocked;
          this.showOwnStores = this.status.showOwnStores;
          this.isCanceled.status = this.status.isCanceled;
          this.isTrial = this.status.isTrial;
          this.autoCollect = this.status.autoCollect;
          // this.forceUpdate = this.status.forceUpdate;
        });
    },
    updateStore(data) {
      console.log("result update store data", data);
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          console.log("result update store is ", result);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "success",
              title: "Update Successfully",
            });
          this.setStoreStatus();
          this.setLocation(this.location.storeID);
        })
        .catch((err) => {
          console.log("test", err);
          this.$swal(err.message, 'Was not found', 'error')
        });
    },
    updateProductRelation(data) {
      console.log("result updateProductRelation data", data);
      return locationService
        .updateProductRelation(this.location.storeID, this.serviceID, data)
        .then((result) => {
          console.log("result updateProductRelation", result);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "success",
              title: "Update Successfully",
            });
          this.setStatus();
          this.setLocation(this.location.storeID);
        })
        .catch((err) => {
          console.log("test", err);
        });
    },
    async updateLock(val) {
      console.log("checkRightStatus", val, this.checkRightStatus(7));
      if (val.value) {
        if (!this.checkRightStatus(7)) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: "You don't have access to lock location.",
            }).then (() => {
              this.isLocked.status = !this.isLocked.status;
            })

          return false;
        }
        if (!this.checkRightStatus(8)) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: "You don't have access to unlock location.",
            }).then (() => {
              this.isLocked.status = !this.isLocked.status;
            })

          return false;
        }
      }
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          lockReason: text,
          isLocked: val.value,
        };
        this.updateProductRelation(data);
      } else {
        this.isLocked.status = !this.isLocked.status;
      }
    },
    async updateShowOwnStores(val) {
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          reason: text,
          showOwnStores: val.value,
        };
        console.log("update locak", data);
        this.updateProductRelation(data);
      } else {
        this.showOwnStores = !this.showOwnStores;
      }
    },
    async updateIsCanceled(val) {
      if (val.value) {
        if (!this.checkRightStatus(12)) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: "You don't have access to cancel location.",
            }).then (() => {
              this.isCanceled.status = !this.isCanceled.status;
            })

          return false;
        }
      }
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          cancelReason: text,
          isCanceled: val.value,
        };
        this.updateProductRelation(data);
      } else {
        this.isCanceled.status = !this.isCanceled.status;
      }
    },
    async updateIsTrial(val) {
      if (val.value) {
        if (!this.checkRightStatus(37)) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: "You don't have access put store on trial.",
            }).then (() => {
               this.isTrial = !this.isTrial;
            })

          return false;
        }
        if (!this.checkRightStatus(38)) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: "You don't have access to take off store from trial.",
            }).then (() => {
              this.isTrial = !this.isTrial;
            })

          return false;
        }
      }
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          lockReason: text,
          isTrial: val.value,
        };
        this.updateProductRelation(data);
      } else {
        this.isTrial = !this.isTrial;
      }
    },
    async updateAutoCollect(val) {
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          autoCollectReason: text,
          autoCollect: val.value,
        };
        this.updateProductRelation(data);
      } else {
        this.autoCollect = !this.autoCollect;
      }
    },
    async updateForceUpdate(val) {
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          forceUpdateReason: text,
          forceUpdate: val.value,
        };
        console.log("update locak", data);
        this.updateStore(data);
      } else {
        this.forceUpdate = !this.forceUpdate;
      }
    },
  },
};
</script>

<style scoped>
</style>
